import React from "react";
import {
  Grid,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import address from "./../images/available.jpeg";
import scalable from "./../images/scalable.jpg";
import cost from "./../images/cost.jpeg";
import tribal from "./../images/tribal.jpg";
import eliminate from "./../images/eliminate.jpeg";

import useMediaQuery from "@mui/material/useMediaQuery";

const ControlCost = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");

  const costStyle = {
    flexGlow: 1,
    padding: vMediaQuery ? "20px" : "50px 140px",
    backgroundColor: "#f7f7f7",
    textAlign: "center",

  };

  return (
    <Box sx={costStyle}>
      <h1 style={{ color: "#357ec7", fontSize: vMediaQuery ? "20px" : "34px" }}>
        Control Costs with GDR Consultancy Services <br />
        (Unique engagement model)
      </h1>
      <Typography variant={vMediaQuery ? "body2" : "subtitle1"}>
        Get access to cutting edge technology at a whopping 50% less cost
        compared to other options with GDR Consultancy {vMediaQuery || <br />}{" "}
        Services. With no usage level commitments and flexibility to scale up or
        down, ODS has become a preferred {vMediaQuery || <br />} choice as 98.7%
        of our customers found GDR Consultancy Services highly beneficial.
      </Typography>
      <Grid
        container
        spacing={0}
        sx={{ padding: vMediaQuery ? "0px" : "0px 40px" }}
      >
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={cost} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "24px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Cost Effective
                <br />
                “PAY-AS-YOU-USE” <br />
                Model
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="cost-contanierLCQ">
              <img className="costLCQ" alt="certificates" src={address} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Address <br />
                Skill Gaps
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={tribal} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Institutionalize Tribal
                <br /> Knowledge
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="costScalable-contanierLCQ">
              <img className="costScalable" alt="certificates" src={scalable} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "10px" : "20px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Availability and
                <br /> Scalability of
                <br /> Resources
              </strong>
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierQ">
              <img className="valuesQ" alt="certificates" src={eliminate} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "20px", fontSize: vMediaQuery ? "14px" : "17px" }}
            >
              <strong>
                Eliminate Capacity <br /> VS. Demand <br />
                Issues
              </strong>
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ControlCost;
